module.exports = __webpack_public_path__ + "static/img/thumb_19.a1e8798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_19.png
// module id = zpUu
// module chunks = 0